import { Component } from '@angular/core'
import { MatCardActions, MatCardFooter } from '@angular/material/card'

@Component({
	selector: 'card-actions',
	templateUrl: './CardActions.Component.html',
	imports: [MatCardFooter, MatCardActions],
})
export class CardActionsComponent {}
